import AuthService from './AuthService';

// Admin-facing help-center CRUD service.
class AdminHelpService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
        this.helpPath = '/admin/help';
    }

    getAuthHeaders(extraHeaders) {
        const token = AuthService.getAccessToken();
        const authHeader = token ? { Authorization: `Bearer ${token}` } : {};
        return {
            ...authHeader,
            ...(extraHeaders || {}),
        };
    }

    async getArticles() {
        const url = `${this.apiBaseUrl}${this.helpPath}`;
        const response = await fetch(url, { method: 'GET', headers: this.getAuthHeaders() });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return await response.json();
    }

    async createArticle(payload) {
        const url = `${this.apiBaseUrl}${this.helpPath}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(payload || {}),
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return await response.json();
    }

    async updateArticle(articleId, payload) {
        if (!articleId) throw new Error('articleId is required');
        const url = `${this.apiBaseUrl}${this.helpPath}/${encodeURIComponent(articleId)}`;
        const response = await fetch(url, {
            method: 'PUT',
            headers: this.getAuthHeaders({ 'Content-Type': 'application/json' }),
            body: JSON.stringify(payload || {}),
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return await response.json();
    }

    async deleteArticle(articleId) {
        if (!articleId) throw new Error('articleId is required');
        const url = `${this.apiBaseUrl}${this.helpPath}/${encodeURIComponent(articleId)}`;
        const response = await fetch(url, { method: 'DELETE', headers: this.getAuthHeaders() });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const text = await response.text();
        try {
            return text ? JSON.parse(text) : { ok: true };
        } catch {
            return { ok: true };
        }
    }
}

const adminHelpService = new AdminHelpService();
export { AdminHelpService };
export default adminHelpService;
